import { Row,Col, Button } from "reactstrap";
import { StatusList } from './FormComponents';
import { useState, useContext, useEffect,ChangeEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCopy} from '@fortawesome/free-solid-svg-icons';
import { PageContext } from './PageContext';
import { UserContext } from "./UserContext";
import { showFields,fieldLables } from "./Configuration";
import { ShowFields,FieldLabels, FieldValues,AdToApprove, longDateTime } from "../services/interfaces";
import { AccountNotes } from "./AccountNotes";
import { getDeadlines } from "../services/apiService";
import { makeLongDateTime } from "./DateTimeHelpers";
import { Grid, GridCellsSettings, GridColumn, GridCustomCellProps } from "@progress/kendo-react-grid";
export function AdJacket(){
    const pageContext = useContext(PageContext);
    const userContext = useContext(UserContext);
    const [fldLabels, setFldLabels]=useState<FieldLabels>();
    const [shwFields, setShwFields]=useState<ShowFields>();
    const [deadlines,setDeadlines]=useState();
    const [accountNotesVisible, setAccountNotesVisible]=useState(false);
    const [ajFields, setAjFields]=useState<FieldValues>({
        
            Status: pageContext?.selectedAd.status||"",
            Customer: pageContext?.selectedAd.customer||"",
            Account: pageContext?.selectedAd.fileSize2||"",
            Site: pageContext?.selectedAd.file1||"",
            Size: pageContext?.selectedAd.size||"",
            rCopyUO: "",
            TmpChar2: pageContext?.selectedAd.tmpChar2||"",
            Salesman: pageContext?.selectedAd.salesman||"",
            Deadline: pageContext?.selectedAd.currentDeadline.toString()||"",
            Type: pageContext?.selectedAd.category||"",
            SubStatus: "",
            Section: pageContext?.selectedAd.fileSize1||"",
            Team: "",
            Color: pageContext?.selectedAd.rCopyStatus||"",
            Tagline: pageContext?.selectedAd.comment2||"",
            Comment: pageContext?.selectedAd.comment||"",
            Key: "",
            Temp3: "",
            ParentAd: pageContext?.selectedAd.groupAdNum||"",
            Queue: pageContext?.selectedAd.queue||"",
            rCopyLines:pageContext?.selectedAd.rCopyLines||""
        
    });

    //console.log(pageContext?.uiFeatures);
    function setNewStatus(stat:string[]){
        //console.log(stat);
    }
    const fetchLabels = () => {
        fieldLables().then(labels=>{
            //console.log(labels);
            setFldLabels(labels);
        });
    };
    const fetchShow = async()=>{
        showFields().then(show=>{
            //console.log(show);
            setShwFields(show);
        });
    }

    const showAccountNotes=()=>{
        setAccountNotesVisible(true);
    }
    const hideAccountNotes=()=>{
        setAccountNotesVisible(false);
    }

    function setAjCustomer(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,Customer:event.target.value});
    }
    function setAjAccount(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,Account:event.target.value});
    }
    function setAjStatus(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,Status:event.target.value});
    }
    function setAjSize(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,Size:event.target.value});
    }
    function setAjRCopyUO(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,rCopyUO:event.target.value});
    }
    function setAjTmpChar2(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,TmpChar2:event.target.value});
    }
    function setAjSalesman(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,Salesman:event.target.value});
    }
    function setAjType(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,Type:event.target.value});
    }
    function setAjSubStatus(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,SubStatus:event.target.value});
    }
    function setAjQueue(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,Queue:event.target.value});
    }
    function setAjTeam(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,Team:event.target.value});
    }
    function setAjSection(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,Section:event.target.value});
    }
    function setAjTagline(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,Tagline:event.target.value});
    }
    function setAjComment(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,Comment:event.target.value});
    }
    function setAjKey(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,Key:event.target.value});
    }
    function setAjParent(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,ParentAd:event.target.value});
    }
    function setAjTemp3(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,Temp3:event.target.value});
    }
    function setAjRCopyLines(event:ChangeEvent<HTMLInputElement>){
        setAjFields({...ajFields,rCopyLines:event.target.value});
    }

    const ajDisabled = ()=>{
        //console.log("AdJacket Enabled: " + pageContext?.uiFeatures.adJacketEnabled);
        return (!pageContext?.uiFeatures.adJacketEnabled);
    }
    const ajTaglineDisabled = ()=>{
        //console.log("Tagline Enabled: " + pageContext?.uiFeatures.editTagLine);
        return (!pageContext?.uiFeatures.editTagLine);
    }

    function copyClipboard(field:string){
        var fieldVal = "";
        switch(field){
            case "slug":
                fieldVal=pageContext?.selectedAd.slug || "";
                break
            case "customer":
                fieldVal=ajFields.Customer || "";
                break;
            case "account":
                fieldVal=ajFields.Account || "";
                break;
            case "site":
                fieldVal=ajFields?.Site || "";
                break;
            case "salesman":
                fieldVal=ajFields?.Salesman || "";
                break;
            case "type":
                fieldVal=ajFields?.Type || "";
                break;
            case "tagline":
                fieldVal=ajFields?.Tagline || "";
                break;
            case "comment":
                fieldVal=ajFields?.Comment || "";
                break;
            case "parent":
                fieldVal=ajFields?.ParentAd || "";
                break;
            case "rcopylines":
                fieldVal=ajFields?.rCopyLines || "";
                break;
            case "tmpchar2":
                fieldVal=ajFields?.TmpChar2 || "";
                break;
            case "rcopyuo":
                fieldVal=ajFields?.rCopyUO || "";
                break;
        }
        navigator.clipboard.writeText(fieldVal);
    }

    const openCustWiki=(e: React.MouseEvent)=>{
        e.preventDefault();
        const wikiRoot = pageContext?.glSettings.WikiLink;
        console.log(wikiRoot);
        console.log(ajTaglineDisabled());
        if (wikiRoot){
            var wikiURL = wikiRoot + pageContext?.selectedAd.file1 + "/" + pageContext?.selectedAd.fileSize2;
            console.log(wikiURL);
            window.open(wikiURL);
        }

    }

    const formatLongDateTime=(gridCell:GridCustomCellProps)=>{
        var deadline = gridCell.dataItem.dlVal
        const ldt:longDateTime = {
            year:deadline.substring(0,4),
            month:deadline.substring(4,6),
            day:deadline.substring(6,8),
            hour:deadline.substring(8,10),
            minute:deadline.substring(10,12),
            second:deadline.substring(12,14),
        }
        const newDateTime=new Date(ldt.month+"/"+ldt.day+"/"+ldt.year +" "+ ldt.hour + ":" + ldt.minute + ":" + ldt.second);
        return (
            <td {...gridCell.tdProps}>
            {gridCell.dataItem.dlVal==="0"?"":newDateTime.toString()}
            </td>
        )
    }


   const [formattedDeadline, setFormattedDeadline] = useState<string>("");

   useEffect(() => {
        var locale=pageContext?.glSettings.Locale
        const ldt:longDateTime = {
            year:ajFields.Deadline.substring(0,4),
            month:ajFields.Deadline.substring(4,6),
            day:ajFields.Deadline.substring(6,8),
            hour:ajFields.Deadline.substring(8,10),
            minute:ajFields.Deadline.substring(10,12),
            second:ajFields.Deadline.substring(12,14),
        }
        console.log(ldt);
        const newDateTime=new Date(ldt.month+"/"+ldt.day+"/"+ldt.year +" "+ ldt.hour + ":" + ldt.minute + ":" + ldt.second);

        setFormattedDeadline(newDateTime.toString())
   }, [ajFields.Deadline]);

   useEffect(()=>{
        pageContext?.setSelectedAd(prevObject=>({...prevObject,comment2:ajFields.Tagline}));

   },[ajFields.Tagline])

    //console.log(pageContext?.selectedAd);
    useEffect(()=>{
        fetchLabels();
        fetchShow();
        getDeadlines(pageContext?.selectedAd.element).then(data=>{
                setDeadlines(data)            
            }
        );
    },[]);
    return(
        <div className="expand-tab-content">
            {accountNotesVisible?<AccountNotes onClose={hideAccountNotes}></AccountNotes>:null}
            {shwFields?.Status?             
            <Row>
                <Col xs="2">{fldLabels?.Status}</Col>
                <Col xs="9">        
                    <StatusList setStatus={setNewStatus} value={[ajFields.Status]} type="single" enabled={pageContext?.uiFeatures.adJacketEnabled||false}></StatusList>
                </Col>
                <Col xs="1">
                </Col>
            </Row>
            :null}
            {shwFields?.Customer?
            <Row>
                <Col xs="2">{fldLabels?.Customer}</Col>
                <Col xs="9">        
                    <input id="ajCustomer" className="formField" value={ajFields.Customer} onChange={setAjCustomer} disabled={ajDisabled()}></input>
                </Col>
                <Col xs="1">
                    <a href="#" onClick={() => copyClipboard("customer")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            {shwFields?.Account?
            <Row>
                <Col xs="2">{fldLabels?.Account}</Col>
                <Col xs="5">        
                    <input id="ajAccount" className="formField" value={ajFields.Account||""} onChange={setAjAccount} disabled={ajDisabled()}></input>
                </Col>
                <Col xs="1">
                    {(pageContext?.selectedAd.accountNotes ?? 0) > 0 && (userContext?.user?.type ?? 0) > 0 ?
                        <Button size="sm" onClick={showAccountNotes}>Notes</Button>
                    :null}
                </Col>
                <Col xs="3">
                    {pageContext?.glSettings.WikiLink!=""?
                        <Button size="sm" onClick={openCustWiki}>Customer Wiki</Button>
                    :null}
                </Col>
                <Col xs="1">
                <a href="#" onClick={() => copyClipboard("account")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            {shwFields?.Site?
            <Row>
                <Col xs="2">{fldLabels?.Site}</Col>
                <Col xs="9">        
                    <input id="ajSite" className="formField" value={ajFields.Site} disabled={true}></input>
                </Col>
                <Col xs="1">
                <a href="#" onClick={() => copyClipboard("site")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            {shwFields?.Size?
            <Row>
                <Col xs="2">{fldLabels?.Size}</Col>
                <Col xs="9">        
                    <input id="ajSize" className="formField" value={ajFields.Size} onChange={setAjSize} disabled={ajDisabled()}></input>
                </Col>
                <Col xs="1">
                <a href="#" onClick={() => copyClipboard("size")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            {shwFields?.rCopyUO?
            <Row>
                <Col xs="2">{fldLabels?.rCopyUO}</Col>
                <Col xs="9">        
                    <input id="ajRCopyUo" className="formField" onChange={setAjRCopyUO} disabled={ajDisabled()}></input>
                </Col>
                <Col xs="1">
                <a href="#" onClick={() => copyClipboard("rcopyuo")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            {shwFields?.TmpChar2?
            <Row>
                <Col xs="2">{fldLabels?.TmpChar2}</Col>
                <Col xs="9">        
                    <input id="ajTmpChar2" className="formField" value={ajFields.TmpChar2} onChange={setAjTmpChar2} disabled={ajDisabled()} ></input>
                </Col>
                <Col xs="1">
                <a href="#" onClick={() => copyClipboard("tmpchar2")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            {shwFields?.Salesman?
            <Row>
                <Col xs="2">{fldLabels?.Salesman}</Col>
                <Col xs="9">        
                    <input id="ajSalesRep" className="formField" value={ajFields.Salesman} onChange={setAjSalesman} disabled={ajDisabled()}></input>
                </Col>
                <Col xs="1">
                    <a href="#" onClick={() => copyClipboard("salesman")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            {shwFields?.Deadline?
            <Row>
                <Col xs="2">{fldLabels?.Deadline}</Col>
                <Col xs="9">        
                    <input id="ajDeadline" className="formField" value={formattedDeadline} disabled={true}></input>
                </Col>
            </Row>
            :null}
            {shwFields?.Type?
            <Row>
                <Col xs="2">{fldLabels?.Type}</Col>
                <Col xs="9">        
                    <input id="ajCategory" className="formField" value={ajFields.Type} onChange={setAjType} disabled={ajDisabled()}></input>
                </Col>
                <Col xs="1">
                    <a href="#" onClick={() => copyClipboard("type")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            {shwFields?.SubStatus?
            <Row>
                <Col xs="2">{fldLabels?.SubStatus}</Col>
                <Col xs="9">        
                    <input id="ajSubStatus" className="formField" value={ajFields.SubStatus} onChange={setAjSubStatus} disabled={ajDisabled()}></input>
                </Col>
                <Col xs="1">
                </Col>
            </Row>
            :null}
            {shwFields?.Queue?
            <Row>
                <Col xs="2">{fldLabels?.Queue}</Col>
                <Col xs="9">        
                    <input id="ajSource" className="formField" value={ajFields.Queue} onChange={setAjQueue} disabled={ajDisabled()}></input>
                </Col>
            </Row>
            :null}
            {shwFields?.Section?
            <Row>
                <Col xs="2">{fldLabels?.Section}</Col>
                <Col xs="9">        
                    <input id="ajSection" className="formField" value={ajFields.Section} onChange={setAjSection} disabled={ajDisabled()}></input>
                </Col>
            </Row>
            :null}
            {shwFields?.Team?
            <Row>
                <Col xs="2">{fldLabels?.Team}</Col>
                <Col xs="9">        
                    <input id="ajTeam" className="formField"  value={ajFields.Team} onChange={setAjTeam} disabled={ajDisabled()}></input>
                </Col>
            </Row>
            :null}
            {shwFields?.Color?
            <Row>
                <Col xs="2">{fldLabels?.Color}</Col>
                <Col xs="9">        
                    <input id="ajColor" className="formField" value={ajFields.Color} onChange={setAjRCopyUO} disabled={ajDisabled()}></input>
                </Col>
            </Row>
            :null}
            {shwFields?.Tagline?
            <Row>
                <Col xs="2">{fldLabels?.Tagline}</Col>
                <Col xs="9">  
                    <input id="ajTagline" className="formField" value={ajFields.Tagline} onChange={setAjTagline} disabled={ajTaglineDisabled()}></input>
                </Col>
                <Col xs="1">
                    <a href="#" onClick={() => copyClipboard("tagline")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            {shwFields?.Comment?
            <Row>
                <Col xs="2">{fldLabels?.Comment}</Col>
                <Col xs="9">        
                    <input id="ajComment" className="formField" value={ajFields.Comment} onChange={setAjComment} disabled={ajDisabled()}></input>
                </Col>
                <Col xs="1">
                    <a href="#" onClick={() => copyClipboard("comment")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            {shwFields?.Key?
            <Row>
                <Col xs="2">{fldLabels?.Key}</Col>
                <Col xs="9">        
                    <input id="ajKey" className="formField" value={ajFields.Key} onChange={setAjKey} disabled={ajDisabled()}></input>
                </Col>
                <Col xs="1">
                    <a href="#" onClick={() => copyClipboard("key")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            {shwFields?.ParentAd?
            <Row>
                <Col xs="2">{fldLabels?.ParentAd}</Col>
                <Col xs="9">        
                    <input id="ajParent" className="formField" value={ajFields.ParentAd} onChange={setAjParent} disabled={ajDisabled()}></input>
                </Col>
                <Col xs="1">
                    <a href="#" onClick={() => copyClipboard("parent")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            {shwFields?.Temp3?
            <Row>
                <Col xs="2">{fldLabels?.Temp3}</Col>
                <Col xs="9">        
                    <input id="ajTemp3" className="formField" value={ajFields.Temp3} onChange={setAjTemp3} disabled={ajDisabled()}></input>
                </Col>
                <Col xs="1">
                    <a href="#" onClick={() => copyClipboard("temp3")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            {shwFields?.rCopyLines?
            <Row>
                <Col xs="2">{fldLabels?.rCopyLines}</Col>
                <Col xs="9">        
                    <input id="ajTemp3" className="formField" value={ajFields.rCopyLines} onChange={setAjRCopyLines} disabled={ajDisabled()} ></input>
                </Col>
                <Col xs="1">
                    <a href="#" onClick={() => copyClipboard("rcopylines")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
                </Col>
            </Row>
            :null}
            <Row>
                <h5>Deadlines</h5>
                <Grid
                    data={deadlines}  
                >
                    <GridColumn field="dlName" title="Type" width="250" />
                    <GridColumn field="dlVal" title="Deadline" cells={{data:formatLongDateTime}}/>
                </Grid>
            </Row>
        </div>
    );
}